import { Trash2 } from 'lucide-react'
import { renderToString } from 'react-dom/server'

import { CustomAgGrid, createContextMenu } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'
import { Button } from '@fortem-monorepo/react-ui'
import { MarketSummary } from '@fortem-monorepo/web-sdk'

import { useMarketSummaryActions } from '@/pages/instruments/market-summary/market-summary-actions'
import { useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'

export const MarketSummaryDisplayInstrumentsTab = () => {
  const { view, displayInstrumentsQuery, hasWriteAccess } = useMarketSummaryContext()
  const { removeInstrumentFromDisplay, actionState } = useMarketSummaryActions()

  const contextMenu = createContextMenu<MarketSummary.Instrument>((params) => {
    const row = params.node?.data
    const defaults = params.defaultItems ?? []
    if (!row || params.node?.group || !hasWriteAccess || !view) return defaults
    return [
      ...(hasWriteAccess
        ? [
            {
              name: 'Remove Instrument',
              icon: renderToString(<Trash2 size={16} />),
              cssClasses: ['text-red-600!'],
              disabled: actionState !== null,
              action: () => removeInstrumentFromDisplay({ display_id: view.display_id, instrument: row }),
            },
            'separator',
          ]
        : ([] as any)),
      ...defaults,
    ]
  })

  return (
    <div className="flex h-full flex-col gap-2">
      {displayInstrumentsQuery.isError && (
        <div role="alert" className="flex items-center gap-2 text-sm text-destructive">
          Unable to load instruments.
          <Button size="sm" variant="outline" onClick={() => void displayInstrumentsQuery.refetch()}>
            Retry
          </Button>
        </div>
      )}
      <Widget exposed className="min-h-0 flex-1">
        <WidgetHeaderWithQuery query={displayInstrumentsQuery} title="Display instruments" />
        <WidgetContent loading={displayInstrumentsQuery.isLoading}>
          <CustomAgGrid
            getContextMenuItems={contextMenu}
            rowData={displayInstrumentsQuery.data ?? []}
            query={displayInstrumentsQuery}
            getRowId={({ data }) => data.instrument_id.toString()}
            domLayout="normal"
            columnDefs={[
              { field: 'unique_identifier', headerName: 'Identifier' },
              { field: 'long_name', headerName: 'Name', flex: 1, minWidth: 180 },
              { field: 'section', headerName: 'Section' },
              { field: 'bucket', headerName: 'Bucket' },
              { field: 'value_type', headerName: 'Value type' },
            ]}
          />
        </WidgetContent>
      </Widget>
    </div>
  )
}
